export default __webpack_public_path__ + "static/media/feature-item-series.5b0c7ca0.svg";